import { ClientConfigProductName } from '@frontend/vanilla/core';

import { clientConfigAppGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'payments',
            loadChildren: () => import('@frontend/payments/cashier-entrypoint-lib').then((t) => t.PAYMENTS_ROUTES),
            canMatch: [clientConfigAppGuard],
            canActivate: [productUnderMaintenanceGuard],
            data: { product: ClientConfigProductName.PAYMENTS },
        },
    ],
};

export default routes;
